import styled from 'styled-components'

import { Layout, Text } from '@loadsmart/miranda-react'
import { getToken } from '@loadsmart/miranda-react/dist/tokens'

import { useTrackingOnboardingContext } from '../../../TrackingOnboardingContext'
import ImageManual from '../../assets/tracking-onboarding-finalize-connection-manual.png'

const StyledListItem = styled.li`
  padding-bottom: ${getToken('spacing-2')};
  list-style: decimal;
`

export default function ManualFinalizeConnectionContent() {
  const { hasPreviousTracking } = useTrackingOnboardingContext()

  if (hasPreviousTracking) {
    return (
      <Layout.Group style={{ flexWrap: 'nowrap' }} gap="spacing-12">
        <Layout.Stack gap="spacing-4">
          <Text variant="body-md-bold">Manual tracking</Text>
          <Layout.Stack gap="spacing-6">
            <Text variant="body-md">
              You're about to confirm your preferred connection as Manual.
            </Text>
            <Text variant="body-md">You can update this choice anytime via the tracking card.</Text>
          </Layout.Stack>
        </Layout.Stack>
        <img src={ImageManual} alt="" width={250} height={220} />
      </Layout.Group>
    )
  }

  return (
    <Layout.Group style={{ flexWrap: 'nowrap' }} gap="spacing-12">
      <Layout.Stack gap="spacing-4">
        <Text variant="body-md-bold">Add yourself the driver's locations</Text>
        <Text variant="body-md">
          Manual locations are simple and straight forward, and you can do it through our platform.
        </Text>
        <Layout.Group paddingL="spacing-4">
          <Text variant="body-md">
            <ol>
              <StyledListItem>
                Access the tracking card inside the shipment details page to find where to add
                locations
              </StyledListItem>
              <StyledListItem>
                Inform the city/state, date and time from the driver's location
              </StyledListItem>
              <StyledListItem>
                Submit the location and it will be logged, you will be also able to remove if
                necessary
              </StyledListItem>
            </ol>
          </Text>
        </Layout.Group>
      </Layout.Stack>
      <img src={ImageManual} alt="" width={250} height={220} />
    </Layout.Group>
  )
}
